import React, { useEffect, useState } from 'react';
import { Standing } from '../models/Standing';
import { getGroupStandings } from '../services/MatchService';
import { currentSeason } from '../Constants';
import { Link } from 'react-router-dom';

const GroupsPage = () => {
    const [standings, setStandings] = useState<{ [key: string]: Standing[] }>({});

    const getStandings = async () => {
        try {
            const response = await getGroupStandings(currentSeason);
            setStandings(response);
        } catch (error) {
            console.error('Error fetching standings:', error);
        }
    };

    useEffect(() => {
        getStandings(); // Fetch standings when the component mounts
    }, []);

    if (Object.keys(standings).length === 0) {
        return <p className="text-center">Ingen grupper fundet</p>;
    }

    return (
        <div>
            <div className='row'>
                {Object.keys(standings).map((groupKey) => (
                    <div className='col-md-6' key={groupKey}>
                        <h2>Gruppe {groupKey}</h2>
                        <table className="table table-secondary">
                            <thead>
                                <tr>
                                    <th>Team</th>
                                    <th>Kampe spilet</th>
                                    <th>W/L</th>
                                    <th>Points</th>
                                </tr>
                            </thead>
                            <tbody>
                                {standings[groupKey].map((standing, idx) => (
                                    <tr key={idx}>
                                        <td>
                                            <Link to={`/team/${standing.team.teamId}`} className='text-decoration-none'>
                                                <img src={standing.team.teamLogo} alt={`${standing.team.teamName} Logo`} width={40} />
                                                {standing.team.teamName}
                                            </Link>
                                        </td>
                                        <td>{standing.gamesPlayed}</td>
                                        <td>{standing.wins}/{standing.gamesPlayed - standing.wins}</td>
                                        <td>{standing.points}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default GroupsPage;
